import styled, { css } from 'styled-components'
import { generateMedia } from 'styled-media-query'

const media = generateMedia({
  xs: '350px',
  sm: '550px',
  md: '768px',
  lg: '1200px',
})
type progressTypes={
  stage:number
}
export const Wrapper = styled.div`
.input{
  margin: auto;
  width: 80%;
  padding-top:1%;
  padding-right:10%;
  padding-bottom:1%;
  padding-left:10%;
}
${({ theme }) => css`
  height: 80%;
  width: 80%;
  background: #FFFFFF;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin: auto;
  h1{
    font-family: 'Comfortaa';
    font-style: normal;
    --BaseFontSize: 30px;
    --BaselineHeight: 33px;
    padding: 1px;
    color: #000000;
    text-align: center;
    font-weight: 400;
    font-size: var(--BaseFontSize);
    line-height: var(--BaselineHeight);
  

    ${media.between('sm', 'md')`
    font-size: calc(var(--BaseFontSize) / 1,5625);
    line-height: calc(var(--BaselineHeight) / 1,5625);
    `
}
    ${media.between('xs', 'sm')`
    font-size: calc(var(--BaseFontSize) 2,181);
    line-height: calc(var(--BaselineHeight) 2,181);
    `
}
    ${media.lessThan('xs')`
    font-size: calc(var(--BaseFontSize)/3,428);
    line-height: calc(var(--BaselineHeight)/3,428);
    `}
  }

h2{
  text-align: center;
  font-family: 'Comfortaa';
  font-style: normal;
  --BaseFontSize: 20px;
  --BaselineHeight: 18px;
  font-weight: 400;
  font-size: var(--BaseFontSize);
  line-height: var(--BaselineHeight);
  color: ${theme.colors.gray};
  ${media.between('sm', 'md')`
    font-size: calc(var(--BaseFontSize) / 1,5625);
    line-height: calc(var(--BaselineHeight) / 1,5625);
    `}
    ${media.between('xs', 'sm')`
    font-size: calc(var(--BaseFontSize) 2,181);
    line-height: calc(var(--BaselineHeight) 2,181);
    `}
    ${media.lessThan('xs')`
    font-size: calc(var(--BaseFontSize)/3,428);
    line-height: calc(var(--BaselineHeight)/3,428);
    `}
}
.stepButton{
  margin-top: 5%;
  width: 60%;
  margin-left: 20%;
  display: flex;
  gap: 20px;
  justify-content: center;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.2);

}

`
}
${media.between('sm', 'md')`
    font-size: calc(var(--BaseFontSize) / 1,5625);
    line-height: calc(var(--BaselineHeight) / 1,5625);
    `}
    ${media.between('xs', 'sm')`
    font-size: calc(var(--BaseFontSize) 2,181);
    line-height: calc(var(--BaselineHeight) 2,181);
    `}
    ${media.lessThan('xs')`
    font-size: calc(var(--BaseFontSize)/3,428);
    line-height: calc(var(--BaselineHeight)/3,428);
    `}
`
export const ProgressBar = styled.div`
width: 100%;
height: 2%;
border-radius: 16px;
margin-bottom: 5%;
`
export const Progress = styled.div<progressTypes>`
${({ stage }) => css`
background: linear-gradient(270.04deg, #9FFFC7 0.02%, #017849 97.37%);
width: calc(33.3%*${stage});
height: 100%;
border-radius: 16px;
`
}
`
